import moment from 'moment-timezone';
import { getTableColumn, TableColumn } from '@shared/UI';
import { IServiceAchRelationshipsDto } from '@shared/api';
import { useAchRelationshipsTable } from './AchRelationshipsTableProvider';
import { FilterArrowsIcon } from '@shared/icons/FilterArrowsIcon';
import { IconType } from 'react-icons';
import { getHeaderClassName } from '@shared/UI/SimpleTable/lib/getHeaderClassName';
import { HeaderCellWithFilter } from '@shared/UI/SimpleTable/components/HeaderCellWithFilter';
import { formats } from '@shared/utils';

export function getAchRelationshipsTableColumns(): TableColumn<IServiceAchRelationshipsDto>[] {
    const { desc, sortFieldName, handleSecuritiesSort } = useAchRelationshipsTable();

    return [
        getTableColumn({
            dataField: 'id',
            flex: 0.4,
            firstColumn: true,
            headerFormatter: (row) => (
                <HeaderCellWithFilter
                    title={String(row)}
                    icon={FilterArrowsIcon as IconType}
                    onClick={() => handleSecuritiesSort('id')}
                />
            ),
            headerClassName: `ach-relationships-table-header ${getHeaderClassName(sortFieldName, desc, 'id')}`,
        }),
        getTableColumn({
            dataField: 'routingNumber',
            flex: 0.3,
            headerFormatter: (row) => (
                <HeaderCellWithFilter
                    title={String(row)}
                    icon={FilterArrowsIcon as IconType}
                    onClick={() => handleSecuritiesSort('routingNumber')}
                />
            ),
            headerClassName: `ach-relationships-table-header ${getHeaderClassName(
                sortFieldName,
                desc,
                'routingNumber',
            )}`,
        }),
        getTableColumn({
            dataField: 'accountNumber',
            flex: 0.3,
            headerFormatter: (row) => (
                <HeaderCellWithFilter
                    title={String(row)}
                    icon={FilterArrowsIcon as IconType}
                    onClick={() => handleSecuritiesSort('accountNumber')}
                />
            ),
            headerClassName: `ach-relationships-table-header ${getHeaderClassName(
                sortFieldName,
                desc,
                'accountNumber',
            )}`,
        }),
        getTableColumn({
            dataField: 'accountOwnerName',
            flex: 0.3,
            headerFormatter: (row) => (
                <HeaderCellWithFilter
                    title={String(row)}
                    icon={FilterArrowsIcon as IconType}
                    onClick={() => handleSecuritiesSort('accountOwnerName')}
                />
            ),
            headerClassName: `ach-relationships-table-header ${getHeaderClassName(
                sortFieldName,
                desc,
                'accountOwnerName',
            )}`,
        }),
        getTableColumn({
            dataField: 'alias',
            flex: 0.3,
            headerFormatter: (row) => (
                <HeaderCellWithFilter
                    title={String(row)}
                    icon={FilterArrowsIcon as IconType}
                    onClick={() => handleSecuritiesSort('alias')}
                />
            ),
            headerClassName: `ach-relationships-table-header ${getHeaderClassName(sortFieldName, desc, 'alias')}`,
        }),
        getTableColumn({
            dataField: 'createdAt',
            flex: 0.4,
            headerFormatter: (row) => (
                <HeaderCellWithFilter
                    title={String(row)}
                    icon={FilterArrowsIcon as IconType}
                    onClick={() => handleSecuritiesSort('createdAt')}
                />
            ),
            headerClassName: `ach-relationships-table-header ${getHeaderClassName(sortFieldName, desc, 'createdAt')}`,
            formatter: (data) => moment(String(data)).format(formats.fullTime),
        }),
    ];
}
